import React, { ReactNode, useEffect, useState } from "react";
import { useNavigate } from "react-router";

interface UnAuthGuardProps {
  component: ReactNode;
}

const UnAuthGuard: React.FC<UnAuthGuardProps> = ({ component }) => {
  const [status, setStatus] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    checkToken();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const checkToken = () => {
    const token = localStorage.getItem("token");

    if (token === null) {
      localStorage.removeItem("token");
    } else {
      navigate("/");
    }

    setStatus(true);
  };

  return status ? (
    <React.Fragment>{component}</React.Fragment>
  ) : (
    <React.Fragment></React.Fragment>
  );
};

export default UnAuthGuard;
